"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styles_1 = tslib_1.__importDefault(require("./styles"));
const styling_1 = require("../../styling");
function LevelPip({ level, classes, id }) {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styles_1.default }, "level-pip");
    return react_1.default.createElement("div", { id: id, className: mergedClasses.root });
}
exports.default = LevelPip;
//# sourceMappingURL=index.js.map